module.exports = __webpack_public_path__ + "static/media/vertical_odin_logo.42d6d772.png";